import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/fonts.css'
import vuetify from './plugins/vuetify'
import money from 'v-money'
import VueMask from 'v-mask'
import VueEasyLightbox from 'vue-easy-lightbox'


import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import movable from "./utils/movableDialog.js"
import './plugins/axios'
import router from './router'
import store from './store'
import i18n from './i18n'
import DataTablePagination from "@/components/DataTablePagination.vue";

Vue.config.productionTip = false

Vue.use(money, {precision: 4})
Vue.use(VueSweetalert2);
Vue.use(VueEasyLightbox)
Vue.use(movable);
Vue.use(VueMask);

Vue.component('data-table-pagination', DataTablePagination)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
